'use client'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { colorWithOrderType } from '@/lib/color/type'
import { itemOptionType, itemType } from '@/lib/item/server'
import { serviceType } from '@/lib/service/server'
import { sizeWithOrderType } from '@/lib/size/type'
import { ChevronRight } from 'lucide-react'
import { ItemOptionSelectForm } from '../../item/itemOptionSelectForm'
import { Soldout } from '../../item/soldout'

type SizeButtonProps = {
  service: serviceType
  item: itemType
  colors: colorWithOrderType[]
  sizes: sizeWithOrderType[]
  itemOptions: itemOptionType[]
  buttonText?: string
  hideAddToCartButton?: boolean
}

export const SizeButton: React.FC<SizeButtonProps> = ({
  service,
  item,
  colors,
  sizes,
  itemOptions,
  buttonText,
  hideAddToCartButton = false,
}) => {
  if (!item.stock) {
    return <Soldout />
  }

  return (
    <div className="p-4">
      <Dialog>
        <DialogTrigger className="select-size-button button-color main-color text-white w-full text-base rounded-lg text-center relative font-bold p-4 items-center">
          <p>
            {buttonText ? buttonText : 'サイズ・カラーを選ぶ'}
            <span
              className="absolute font-bold text-2xl text-white"
              style={{ top: '18px', right: '12px' }}
            >
              <ChevronRight strokeWidth={'3px'} width={20} height={20} />
            </span>
          </p>
        </DialogTrigger>
        {!hideAddToCartButton && (
          <DialogTrigger className="mt-4 w-full">
            <AddToCartButton_belowSizeButton />
          </DialogTrigger>
        )}
        <DialogContent className="p-[24px] bg-white w-full rounded-md w-[90%] mx-auto">
          <DialogHeader className="text-left">
            <DialogTitle className="text-sm font-normal">
              商品のオプションを選択してください。
            </DialogTitle>
          </DialogHeader>
          <ItemOptionSelectForm
            service={service}
            item={item}
            colors={colors}
            sizes={sizes}
            itemOptions={itemOptions}
            variant="addCart"
            modal={true}
          />
        </DialogContent>
      </Dialog>
    </div>
  )
}

// カートに追加するボタン、見た目のみ
// DialogTriggerの中に配置するので、button要素は使わない（Hydrationエラーが発生するため）
const AddToCartButton_belowSizeButton = () => {
  return (
    <p
      className={`w-10/12 text-center add-cart-button button-color-reverse main-color-reverse bg-white m-auto rounded-xl font-bold p-3`}
    >
      カートに追加する
    </p>
  )
}
